import { useTranslation } from 'react-i18next';

import { BaseIngredientTabProps } from 'components/desktop/BaseIngredient/BaseIngredientComponent';
import 'components/desktop/BaseIngredient/BaseIngredientComponent.scss';
import FoldableCard from 'components/desktop/_general/Card/FoldableCard/FoldableCard';
import NutritionDiagram from 'components/desktop/_general/NutritionDiagram/NutritionDiagram';

export const BaseIngredientNutritionDiagramCard = ({
	state,
	data,
}: BaseIngredientTabProps): JSX.Element => {
	const { t } = useTranslation();

	const getMacroNutrientChartData = (): { label: string; value: number }[] => {
		if (data.nutrients) {
			const macroWeight = data.nutrients
				.filter((n) => n.isMacroNutrient)
				.reduce(
					(p, c) => p + (state.nutrientValues.find((x) => x.id == c.id)?.value ?? 0),
					0
				);

			const macros = data.nutrients
				.filter((n) => n.isMacroNutrient)
				.map((n) => {
					return {
						label: n.name,
						value:
							(state.nutrientValues.find((x) => x.id == n.id)?.value ?? 0) /
							macroWeight,
					};
				});

			return macros;
		}
		return [];
	};

	return (
		<FoldableCard
			defaultOpen={true}
			dataComponentType="baseingredient-nutriscore-diagram-card"
			title={t('_general:NUTRI_DIAGRAM')}
			content={<NutritionDiagram data={getMacroNutrientChartData()}></NutritionDiagram>}
		></FoldableCard>
	);
};
